import { useState } from "react";

function Helper() {

  const [formData, setFormData] = useState({
    complaintAgainstEmployeeId: "",
    complaintTypeId: "", 
    otherComplaintTypeText: "", // optional
    complaintSubTypeId: "", // optional
    detailOfIncident: "", 
  });

  const [formDataError, setFormDataError] = useState({
    complaintTypeIdError: "",
    complaintAgainstEmployeeIdError: "",
    detailOfIncidentError: "",
  });

  const clearFields = () => {
    setFormData((prev) => ({
      ...prev,
      complaintTypeId: "",
      detailOfIncident: "",
      complaintSubTypeId: null,
      otherComplaintTypeText: "",
    }));
  };

  function validateValidation(formData, setFormDataError) {
    let hasError = false;

    //  Only the required fields (others are optional)
    const requiredFields = [
      "complaintTypeId",
      "complaintAgainstEmployeeId",
      "detailOfIncident",
      "timeOfIncident", // Add this if it's required
    ];

    requiredFields.forEach((fieldName) => {
      const value = formData[fieldName];

      const isEmpty =
        value === "" ||
        value === null ||
        value === undefined ||
        (typeof value === "string" && !value.trim()) ||
        (typeof value === "number" && value === 0); // Add number check

      if (isEmpty) {
        const fieldNameWithSpaces = fieldName
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase());

        setFormDataError((prev) => ({
          ...prev,
          [`${fieldName}Error`]: `${fieldNameWithSpaces} is required.`,
        }));

        hasError = true;
      } else {
        setFormDataError((prev) => ({
          ...prev,
          [`${fieldName}Error`]: "",
        }));
      }
    });

    // 🔸 Additional validation for "Other" complaint type
    if (formData.complaintTypeId && formData.selectedComplaintType?.isOtherType) {
      if (!formData.otherComplaintTypeText?.trim()) {
        setFormDataError((prev) => ({
          ...prev,
          otherComplaintTypeTextError: "Please specify the complaint type",
        }));
        hasError = true;
      }
    }

    // 🔸 Additional validation for sub-types if main type has subTypes
    if (formData.complaintTypeId && formData.selectedComplaintType?.subTypes?.length > 0) {
      if (!formData.subComplaintTypeId) {
        setFormDataError((prev) => ({
          ...prev,
          subComplaintTypeIdError: "Please select a sub-type",
        }));
        hasError = true;
      }
    }

    

    return !hasError;
  }

  return {
    formData,
    setFormData,
    formDataError,
    setFormDataError,
    clearFields,
    validateValidation,
  };
}

export default Helper;
